const pickupTimes = [
  { hour: 7, min: 0 },
  { hour: 7, min: 30 },
  { hour: 8, min: 0 },
  { hour: 8, min: 30 },
  { hour: 9, min: 0 },
  { hour: 9, min: 30 },
  { hour: 10, min: 0 },
  { hour: 10, min: 30 },
  { hour: 11, min: 0 },
  { hour: 11, min: 30 },
  { hour: 12, min: 0 },
  { hour: 12, min: 30 },
  { hour: 13, min: 0 },
  { hour: 13, min: 30 },
  { hour: 14, min: 0 },
  { hour: 14, min: 30 },
  { hour: 15, min: 0 },
  { hour: 15, min: 30 },
  { hour: 16, min: 0 },
  { hour: 16, min: 30 },
  { hour: 17, min: 0 },
  { hour: 17, min: 30 },
  { hour: 18, min: 0 },
  { hour: 18, min: 30 },
  { hour: 19, min: 0 },
  { hour: 19, min: 30 },
  { hour: 20, min: 0 },
  { hour: 20, min: 30 },
  { hour: 21, min: 0 },
  { hour: 21, min: 30 },
  { hour: 22, min: 0 },
  { hour: 22, min: 30 },
  { hour: 23, min: 0 },
  { hour: 23, min: 30 },
];

export default pickupTimes;
